export const WarningSVG = () => {
  return (
    <svg
      className="scale-125"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.84666 17.8447C3.05332 17.946 3.28397 18 3.5153 18H16.4861C16.89 18 17.27 17.8427 17.5553 17.5573C17.842 17.272 18 16.8913 18 16.4867C18 16.2553 17.946 16.0247 17.8447 15.818L11.5296 2.95267C11.241 2.36467 10.6537 2 9.99768 2C9.73636 2 9.48437 2.05867 9.24838 2.17467C8.91239 2.34 8.63574 2.616 8.47041 2.95267L2.15602 15.8187C1.97736 16.1807 1.95136 16.592 2.08203 16.9747C2.21269 17.3573 2.48467 17.6667 2.84666 17.8447ZM9.68969 3.072C9.78636 3.024 9.89102 3 9.99835 3C10.2663 3 10.5143 3.15467 10.6317 3.39333L16.948 16.26C16.9827 16.33 17.0007 16.408 17.0007 16.4867C17 16.624 16.9467 16.7527 16.8494 16.85C16.7521 16.9467 16.6234 17 16.4854 17H3.51396C3.43597 17 3.35797 16.982 3.28797 16.9473C3.03332 16.8227 2.92799 16.514 3.05332 16.2593L9.36837 3.39333C9.43637 3.25467 9.55103 3.14 9.68969 3.072ZM10.0003 13C9.72436 13 9.50037 12.776 9.50037 12.5V7.49999C9.50037 7.22399 9.72436 6.99999 10.0003 6.99999C10.2757 6.99999 10.5003 7.22399 10.5003 7.49999V12.5C10.5003 12.7753 10.2757 13 10.0003 13ZM10.0004 15.5C9.58708 15.5 9.25043 15.1634 9.25043 14.75C9.25043 14.3367 9.58708 14 10.0004 14C10.4137 14 10.7504 14.3367 10.7504 14.75C10.7504 15.1634 10.4137 15.5 10.0004 15.5Z"
        fill="#B90000"
      />
    </svg>
  );
};
